<template>
  <div>
    <div class="col-12">
      <h5 class="py-3">Sensor</h5>
      <div class="py-2 d-flex flex-nowrap" v-for="(sensor, i) in sensors.arr" :key="i">
        <div class="pe-2 text-start" style="min-width: 200px;">{{ sensor.label }}</div>
        <input class="w-25" type="number" v-model.lazy="sensor.value">
        <div class="ps-2" style="min-width: 100px;">{{sensor.unit}}</div>
      </div>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmitSensor(sensors.arr)">確認</button>
      <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
    </div>
  </div>

</template>

<script setup>
import {reactive} from "vue";

const emit = defineEmits(['getSensorsData'])


const sensors = reactive({'arr': [
    {label: 'CPULoad', value: 10, unit: 'LOAD' },
    {label: 'CPUTemperature', value: 10, unit: 'TEMP' },
    {label: 'GPULoad', value: 10, unit: 'LOAD' },
    {label: 'GPUTemperature', value: 10, unit: 'TEMP' },
    {label: 'PumpRPM', value: 10, unit: 'RPM' },
    {label: 'CoolantTemp', value: 10, unit: 'TEMP' },
    {label: 'RAM', value: 10, unit: 'RAM' },
    {label: 'CPUPower', value: 10, unit: 'POWER' }
  ]})

function handleSubmitSensor (item) {
  const newSensors = item
  const originJson = JSON.parse(JSON.stringify(require('@/json/DefaultSensor.json')))
  // 迴圈遍歷物件
  for (const key in originJson) {
    newSensors.map(function (sensor) {
      // 取得鍵對應的物件值
      const value = originJson[sensor.label]
      Object.assign(value, {Value: sensor.value})
    })
  }
  const processJson = JSON.stringify(originJson)
  emit('getSensorsData', processJson)
}
function handleInit () {
  sensors.arr = [
    {label: 'CPULoad', value: 10, unit: 'LOAD' },
    {label: 'CPUTemperature', value: 10, unit: 'TEMP' },
    {label: 'GPULoad', value: 10, unit: 'LOAD' },
    {label: 'GPUTemperature', value: 10, unit: 'TEMP' },
    {label: 'PumpRPM', value: 10, unit: 'RPM' },
    {label: 'CoolantTemp', value: 10, unit: 'TEMP' },
    {label: 'RAM', value: 10, unit: 'RAM' },
    {label: 'CPUPower', value: 10, unit: 'POWER' }
  ]
}

</script>
